import { HStack } from '@pets-ui/HStack/HStack'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { type ReactNode } from 'react'

export interface CardSectionProps {
  title: string
  children: ReactNode
  description?: string
}

export const CardSection = (props: CardSectionProps) => {
  const { title, children, description } = props
  return (
    <Paper elevation={0} borderRadius={8} p={4}>
      <VStack gap={2}>
        <HStack gap={2}>
          <Text variant="subtitle" color={colors.grey900}>
            {title}
          </Text>
          {description && (
            <Text variant="caption" color={colors.grey600}>
              {description}
            </Text>
          )}
        </HStack>
        {children}
      </VStack>
    </Paper>
  )
}
